import { render, staticRenderFns } from "./FactsheetBedrijventerreinen.vue?vue&type=template&id=785604c3&"
import script from "./FactsheetBedrijventerreinen.vue?vue&type=script&lang=js&"
export * from "./FactsheetBedrijventerreinen.vue?vue&type=script&lang=js&"
import style0 from "./FactsheetBedrijventerreinen.vue?vue&type=style&index=0&id=785604c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports